@let teaserValue = teaser();
@if (teaserValue) {
  <div class="teaser-container">
    <div class="teaser-text">{{ teaserValue }}</div>
    <a
      [href]="url"
      class="btn-app-edit"
      mat-flat-button
      target="_blank"
      type="button">
      {{ 'BUTTON.MORE' | translate }}
    </a>
  </div>
}
